// extracted by mini-css-extract-plugin
module.exports = {"lumenoreBasePageLoaderContainer":"PageLoader_lumenoreBasePageLoaderContainer__dV_8h","lumenorePageLoader":"PageLoader_lumenorePageLoader__lJjdS","l3":"PageLoader_l3__pT1Uw"};